import { createRouter } from '@tanstack/react-router'

import { routeTree } from '@/app/routeTree.gen'

/**
 * Application router. `defaultPreload: 'intent'` warms route code and loaders on
 * hover/focus for snappy navigation under load.
 */
export const router = createRouter({
  routeTree,
  defaultPreload: 'intent',
  defaultPreloadStaleTime: 0,
  scrollRestoration: true,
})

// Register the router instance for end-to-end type inference across the app.
declare module '@tanstack/react-router' {
  interface Register {
    router: typeof router
  }
}
